import React from 'react';
export function Hero() {
  return <div className="bg-gradient-to-r from-red-50 to-green-50" data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-121">
        <div className="text-center" data-id="element-122">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-123">
            Christmas Holiday Collection
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-124">
            Discover magical decorations and gifts for the perfect holiday
            season
          </p>
          <button className="bg-red-600 text-white px-8 py-3 rounded-md hover:bg-red-700 transition font-medium" data-id="element-125">
            Shop Now
          </button>
        </div>
      </div>
    </div>;
}